import { gql } from "@apollo/client";

const SPONSOR_BY_ID = gql`
  query sponsor($id: Int!) {
    sponsor(id: $id) {
      id
      title
      link
      sponsorText
      priority
      activeFrom
      activeTo
      image
      club {
        id
        clubName
      }
      platform {
        id
      }
      league {
        id
        title
      }
      federation {
        id
        organizationName
        user {
          email
        }
      }
    }
  }
`;

export default SPONSOR_BY_ID;
